module.exports = __webpack_public_path__ + "static/well-21568ec525a970281c45d8ba411ee984.jpg";